import React from "react";

const LOGO_SRC =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_courts-design-draft/artifacts/a6drg32i_sclogo-crown.webp";

/** Official "The Supreme Courts" shield logo. */
export default function Logo({ size = 48, className = "" }) {
  return (
    <img
      src={LOGO_SRC}
      alt="The Supreme Courts"
      width={size}
      style={{ width: size, height: "auto" }}
      className={`block select-none ${className}`}
      draggable={false}
    />
  );
}
